import React from 'react';

function RefreshIcon({ className, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        id="Round"
        fillRule="evenodd"
        fill="currentColor"
        clipRule="evenodd"
        d="M12 7.7897V5.9997C8.69 5.9997 6 8.6897 6 11.9997C6 12.7897 6.15 13.5597 6.44 14.2497C6.59 14.6097 6.48 15.0197 6.21 15.2897C5.7 15.7997 4.84 15.6197 4.57 14.9497C4.2 14.0397 4 13.0397 4 11.9997C4 7.5797 7.58 3.9997 12 3.9997V2.2097C12 1.7597 12.54 1.5397 12.85 1.8497L15.64 4.6397C15.84 4.8397 15.84 5.1497 15.64 5.3497L12.85 8.1397C12.54 8.4597 12 8.2397 12 7.7897ZM17.56 9.7497C17.41 9.3997 17.52 8.9797 17.79 8.7097C18.3 8.1997 19.16 8.3797 19.43 9.0497C19.8 9.9597 20 10.9597 20 11.9997C20 16.4197 16.42 19.9997 12 19.9997V21.7997C12 22.2397 11.46 22.4597 11.15 22.1497L8.36 19.3597C8.16 19.1597 8.16 18.8497 8.36 18.6497L11.15 15.8597C11.46 15.5397 12 15.7597 12 16.2097V17.9997C15.31 17.9997 18 15.3097 18 11.9997C18 11.2097 17.84 10.4497 17.56 9.7497Z"
      />
    </svg>
  );
}

export default RefreshIcon;
